export enum EntityType {
  COMPANY = 'COMPANY',
  BRAND = 'BRAND',
  SCHOOL = 'SCHOOL',
}
